import { render, staticRenderFns } from "./dapp-box1.vue?vue&type=template&id=5c4cacff&scoped=true&"
import script from "./dapp-box1.vue?vue&type=script&lang=js&"
export * from "./dapp-box1.vue?vue&type=script&lang=js&"
import style0 from "./dapp-box1.vue?vue&type=style&index=0&id=5c4cacff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cacff",
  null
  
)

export default component.exports